import VueCookies from 'vue-cookies'
import Component from './component.vue'

export default {
  install(Vue, options) {
    Vue.use(VueCookies)
    Vue.component('cookies-msg', Component)
  }
};